/**
 * Styled Components - Created by cazarez on 07/05/18.
 */
import styled from 'styled-components'
import Checkbox from 'antd/lib/checkbox'
import { GRAY_DARK } from '../../theme/colors'

export const Container = styled.div`
  padding-top: 30px;
  min-height: 60vh;

  @media (max-width: 768px) {
    min-height: 45vh;
  }
`

export const Text = styled.div`
  color: #fff;
`
export const Title = styled.div`
  color: ${GRAY_DARK};
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
`

export const ShippingMethodContainer = styled.div`
  margin-bottom: 20px;
`

export const ShippinPriorityText = styled.div`
  height: 46px;
  width: 281px;
  color: #5f6062;
  font-size: 16px;
  font-style: italic;
  letter-spacing: 0.11px;
  line-height: 23px;
  margin: 23px 0 20px;
`

export const StyledCheckbox = styled(Checkbox)`
  height: 22px;
  color: #5f6062;
  font-size: 16px;
  letter-spacing: 0.2px;
  line-height: 22px;
  margin: 5px 0;
`

export const ViewAllAddresses = styled.div`
  color: #5f6062;
  font-size: 16px;
  letter-spacing: 0.11px;
  line-height: 22px;
  text-align: right;
  cursor: pointer;
`

export const modalStyle = { top: 20, paddingBottom: '96px' }

export const TitleBulk = styled.div`
  font-weight: bold;
  font-family: Avenir;
  text-align: center;
  font-size: 18px;
  #imgBlk {
    max-width: 80px;
    float: left;
    position: absolute;
    left: 6%;
  }
  #subBlk {
    font-size: 16px;
    color: #2DC75C;
    margin-block: 18px;
  }
  @media (max-width: 698px) {
    #imgBlk {
      max-width: 42px;
      top: 24px;
    }
  }
`

export const onOkStyle = {
  background: '#e4d6b2',
  color: '#363636',
  marginTop: '16px',
  fontWeight: 600,
  textShadow: 'none',
  fontFamily: 'Avenir',
}

export const onCancelStyle = {
  border: 'unset',
  textDecoration: 'underline',
  display: 'inline-flex',
  alignItems: 'center'
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/Shippping/styledComponents.tsx